// extracted by mini-css-extract-plugin
export var backupIcon = "_nl-1";
export var image = "_nl-0";